import { styled } from "@mui/material";

export const MaxContainer = styled("div")`
  width: min(540px, 100%);
  margin: auto;
`;

export const CommentContainer = styled("div")({
  padding: ".4rem 0rem .8rem .4rem",
  display: "flex",
  flexDirection: "row",
  gap: ".4rem",
  form: {
    width: "100%",
  },
});

export const ReplyContainer = styled(CommentContainer)({
  padding: ".4rem 0 .8rem 2.8rem",
});

export const PostsContainer = styled("div")`
  max-width: 550px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  @media (max-width: 560px) {
    width: 100vw;
    padding: 0px 10px;
  }
`;
